<div [innerHTML]="jsonstructuredData" data-cy="structured-datas"></div>
<h2 class="kz-section-title"><span i18n="@@pro.listing.faq.title">Frequently Asked Questions</span></h2>
<ng-container *ngIf="jobType === 'decorator'">
  <h3 class="kz-subtitle" i18n="@@pro.listing.faq.subtitle">Our advice for a successful interior design project</h3>
</ng-container>

<kz-accordion accordionContext="none" #accordionComponent>
  <ng-container *ngIf="jobType === 'decorator'">
    <kz-accordion-item>
      <ng-template kzAccordionTitle >
        <h3 class="kz-accordion__title" #questions i18n="@@pro.listing.faq.item1.title">Why hire an interior designer?</h3>
      </ng-template>
      <ng-template kzAccordionContent>
        <div  #responses class="kz-accordion__content-wrapper text-center" id="itemA1">
          <h4 class="kz-accordion__item-subtitle" i18n="@@pro.listing.faq.item1.subtitle">The missions of the interior designer are multiple</h4>
          <ul class="kz-accordion__item-hlist">
            <li>
              <app-picture-source
                imgSrc="/assets/images/annuaire/faq/01A.svg"
                height="100" width="90"
                [presets]="'w1000' | imgPreset"
                imgFitHeight="true"
                useWebp="false" useLazyLoad="true"
              ></app-picture-source>
              <p i18n="@@pro.listing.faq.item1.bloc1"><strong>Accompany</strong> you in your furnishing, decoration or renovation projects,</p>
            </li>
            <li>
              <app-picture-source
                imgSrc="/assets/images/annuaire/faq/01B.svg"
                height="100" width="90"
                [presets]="'w1000' | imgPreset"
                imgFitHeight="true"
                useWebp="false" useLazyLoad="true"
              ></app-picture-source>
              <p i18n="@@pro.listing.faq.item1.bloc2">Help you <strong>choose well</strong>, in case of lack of inspiration or if you are overflowing with ideas,</p>
            </li>
            <li>
              <app-picture-source
                imgSrc="/assets/images/annuaire/faq/01C.svg"
                height="100" width="90"
                [presets]="'w1000' | imgPreset"
                imgFitHeight="true"
                useWebp="false" useLazyLoad="true"
              ></app-picture-source>
              <p i18n="@@pro.listing.faq.item1.bloc3"><strong>Save you time</strong> looking for ideas or decoration,</p>
            </li>
            <li>
              <app-picture-source
                imgSrc="/assets/images/annuaire/faq/01D.svg"
                height="100" width="90"
                [presets]="'w1000' | imgPreset"
                imgFitHeight="true"
                useWebp="false" useLazyLoad="true"
              ></app-picture-source>
              <p i18n="@@pro.listing.faq.item1.bloc4">Helping you <strong>take ownership of a place</strong>, whether it is new or to be renovated.</p>
            </li>
          </ul>
          <p i18n="@@pro.listing.faq.item1.content">The profession of interior decorator differs from that of interior designer. If these two planning professionals tend to work together, the architect is called upon to review the structure of your home while the decorator
            <strong>provides advice on decorating and harmonizing your interior decor.</strong></p>
          <a kzButton buttonStyle="flat" buttonTxtStyle="none" target="_blank" [href]="blogUrl + 'decoration-dinterieur/faire-appel-a-un-decorateur-dinterieur-6-raisons-qui-devraient-vous-convaincre/#more-25006'"><span i18n="@@pro.listing.faq.item1.cta">6 reasons to hire an interior designer</span></a>
        </div>
      </ng-template>
    </kz-accordion-item>

    <kz-accordion-item>
      <ng-template kzAccordionTitle >
        <h3 class="kz-accordion__title" #questions i18n="@@pro.listing.faq.item2.title">How to choose your interior decorator?</h3>
      </ng-template>
      <ng-template kzAccordionContent>
        <div  #responses class="kz-accordion__content-wrapper" id="itemA2">
          <h4 class="kz-accordion__item-subtitle" i18n="@@pro.listing.faq.item2.subtitle">Today, the offers of interior decorators and decorators are numerous. So how do you choose the one with which you want to embark on your decoration project?</h4>

          <ul class="kz-accordion__item-vlist">
            <li>
              <app-picture-source
                imgSrc="/assets/images/annuaire/faq/02A.svg"
                height="100" width="90"
                [presets]="'w1000' | imgPreset"
                imgFitHeight="true"
                useWebp="false" useLazyLoad="true"
              ></app-picture-source>
              <p><ng-container i18n="@@pro.listing.faq.item2.bloc1.l1"><strong>Consult the profiles</strong> to take a look at the decoration and layout work, or see the mention of a diploma or training.</ng-container>
                <br><ng-container i18n="@@pro.listing.faq.item2.bloc1.l2">Complete by reading customer reviews.</ng-container></p>
            </li>
            <li>
              <app-picture-source
                imgSrc="/assets/images/annuaire/faq/02B.svg"
                height="100" width="90"
                [presets]="'w1000' | imgPreset"
                imgFitHeight="true"
                useWebp="false" useLazyLoad="true"
              ></app-picture-source>
              <p i18n="@@pro.listing.faq.item2.bloc2">Choose an interior decorator whose <strong>universe you like and
                whose style meets your expectations.</strong> If you are more modern decoration and white walls, avoid going to a decorator or a fan of colored walls and vintage decoration.</p>
            </li>
            <li>
              <app-picture-source
                imgSrc="/assets/images/annuaire/faq/02C.svg"
                height="100" width="90"
                [presets]="'w1000' | imgPreset"
                imgFitHeight="true"
                useWebp="false" useLazyLoad="true"
              ></app-picture-source>
              <p i18n="@@pro.listing.faq.item2.bloc3"><strong>Check their rates</strong> to find the decorator that fits your budget. Ask for several tailor-made quotes from different professionals.</p>
            </li>
            <li>
              <app-picture-source
                imgSrc="/assets/images/annuaire/faq/02D.svg"
                height="100" width="90"
                [presets]="'w1000' | imgPreset"
                imgFitHeight="true"
                useWebp="false" useLazyLoad="true"
              ></app-picture-source>
              <p i18n="@@pro.listing.faq.item2.bloc4"><strong>Discuss with the decorators</strong> via the Kozikaza online chat for any questions regarding your project.</p>
            </li>
          </ul>
          <a kzButton buttonStyle="flat" buttonTxtStyle="none" [routerLink]="['.']"><span i18n="@@pro.listing.faq.item2.cta">See the list of interior designers</span></a>

          <kz-jumbotron>
            <h4 class="kz-light-title"><kz-icons name="infos"></kz-icons>
              <!--💡 --><ng-container i18n="@@pro.listing.faq.item2.info.title">Kozikaza helps you find the rare pearl.</ng-container></h4>
            <p>
              <ng-container i18n="@@pro.listing.faq.item2.info.content.l1">At Kozikaza, the profiles are certified professionals <span kzBadge badgeType="pro">Pro</span> and verified <kz-icons name="certified" tooltipPosition="top-left"></kz-icons> by our teams. Avoid unpleasant surprises and unscrupulous professionals.</ng-container>
              <br><ng-container i18n="@@pro.listing.faq.item2.info.content.l2">Did a decorator catch your eye? Add his profile to your favorites in one click and easily find him in your private space.</ng-container>
            </p>
          </kz-jumbotron>

        </div>
      </ng-template>
    </kz-accordion-item>

    <kz-accordion-item>
      <ng-template kzAccordionTitle >
        <h3 class="kz-accordion__title" #questions i18n="@@pro.listing.faq.item3.title">How can a decorator help you design your interior?</h3>
      </ng-template>
      <ng-template kzAccordionContent>
        <div  #responses class="kz-accordion__content-wrapper" id="itemA3">
          <div class="cols col-img-left">
            <app-picture-source
              imgSrc="/assets/images/annuaire/faq/03A.svg"
              width="235" height="235"
              [presets]="'w1000' | imgPreset"
              imgFitHeight="true"
              useWebp="false" useLazyLoad="true"
            ></app-picture-source>
            <div>
              <p i18n="@@pro.listing.faq.item3.bloc1.l1">From the choice of lighting, to that of colors and
                materials, the interior decorator is a versatile professional. With his expert eye,
                <strong>the decorator advises you in your choices and brings you solutions to optimize your
                  space</strong> thanks to sometimes ingenious storage. He has solid skills in space planning and
                design, acquired through experience or validated by a diploma.
              </p>
              <br>
              <p i18n="@@pro.listing.faq.item3.bloc1.l2">This professional likes to play with the materials,
                volumes and luminosity of each room, in order
                <strong>to enhance your interior and create harmony</strong> by mixing new decorative elements and the
                furniture already present. It is a considerable ally that
                <strong>saves you time</strong>. Indeed, it is he who takes care of your project from A to Z, alongside
                or not an <a [routerLink]="['/', 'pro', 'interior-architect'] | kzLocalize">interior designer</a>.
              </p>
            </div>
          </div>
          <div class="cols col-img-right">
            <app-picture-source
              imgSrc="/assets/images/annuaire/faq/03B.png"
              width="530" height="300"
              [presets]="'w530' | imgPreset"
              imgFitHeight="true"
              useWebp="true" useLazyLoad="true"
            ></app-picture-source>
            <div>
              <p i18n="@@pro.listing.faq.item3.bloc3.l1">The interior decorator allows you <strong>to
                formalize your project</strong> and to project yourself thanks to representations that he creates for
                you (moodboard, models, 3D or 2D plans).
              </p>
              <br>
              <p i18n="@@pro.listing.faq.item3.bloc2.l2">The interior decorator has an address book to offer
                you different service providers with whom he is used to working and can coordinate them on his side.
              </p>
              <a kzButton buttonStyle="flat" buttonTxtStyle="none" target="_blank" [href]="blogUrl + 'decoration-dinterieur/le-role-dun-decorateur-dinterieur/#more-25118'"><span i18n="@@pro.listing.faq.item3.cta">Discover the profession of interior decorator</span></a>
            </div>
          </div>
        </div>
      </ng-template>
    </kz-accordion-item>

    <kz-accordion-item>
      <ng-template kzAccordionTitle >
        <h3 class="kz-accordion__title" #questions i18n="@@pro.listing.faq.item4.title">How much does an interior designer cost?</h3>
      </ng-template>
      <ng-template kzAccordionContent>
        <div  #responses class="kz-accordion__content-wrapper" id="itemA4">
          <p i18n="@@pro.listing.faq.item4.bloc1.l1">The price of an interior decorator varies according to the service requested. A decoration professional knows how to adapt to each type of request and to all budgets.</p>
          <p i18n="@@pro.listing.faq.item4.bloc1.l2">Here are some examples of prices that our professional interior decorators can offer you.</p>

          <table>
            <tr>
              <th><ng-container i18n="@@pro.listing.faq.item4.table.col1.title">Type of service</ng-container></th>
              <th><ng-container i18n="@@pro.listing.faq.item4.table.col2.title">Average prices observed for a room (price often on estimate)</ng-container></th>
            </tr>
            <tr>
              <td><ng-container i18n="@@pro.listing.faq.item4.table.col1.l1">Moodboard</ng-container></td>
              <td><ng-container i18n="@@pro.listing.faq.item4.table.col2.l1">from 30 €</ng-container></td>
            </tr>
            <tr>
              <td><ng-container i18n="@@pro.listing.faq.item4.table.col1.l2">Appointment design advice</ng-container></td>
              <td><ng-container i18n="@@pro.listing.faq.item4.table.col2.l2">from 47 €</ng-container></td>
            </tr>
            <tr>
              <td><ng-container i18n="@@pro.listing.faq.item4.table.col1.l3">Shopping list</ng-container></td>
              <td><ng-container i18n="@@pro.listing.faq.item4.table.col2.l3">40 €</ng-container></td>
            </tr>
            <tr>
              <td><ng-container i18n="@@pro.listing.faq.item4.table.col1.l4">1 hour decoration coaching package</ng-container></td>
              <td><ng-container i18n="@@pro.listing.faq.item4.table.col2.l4">79 €</ng-container></td>
            </tr>
            <tr>
              <td><ng-container i18n="@@pro.listing.faq.item4.table.col1.l5">Moodboard with shopping list</ng-container></td>
              <td><ng-container i18n="@@pro.listing.faq.item4.table.col2.l5">80 €</ng-container></td>
            </tr>
            <tr>
              <td><ng-container i18n="@@pro.listing.faq.item4.table.col1.l6">3D rendered model</ng-container></td>
              <td><ng-container i18n="@@pro.listing.faq.item4.table.col2.l6">85 €</ng-container></td>
            </tr>
          </table>


          <p i18n="@@pro.listing.faq.item4.bloc2.l1">With an interior decorator, avoid disappointments when carrying out the work.
            <strong>The professional provides you with a tailor-made quote where all the elements are listed.</strong> Find the style of the room or the house together, the interior decorator then takes care of preparing a shopping list for you (choice of floors, paintings, decoration) and coordinates the follow-up of the layout with you.</p>

          <a kzButton buttonStyle="flat" buttonTxtStyle="none" target="_blank" [href]="blogUrl + 'decoration-dinterieur/quel-est-le-prix-des-prestations-dun-decorateur-dinterieur/#more-25677'"><span i18n="@@pro.listing.faq.item4.cta">How much does an interior decorator cost?</span></a>
        </div>
      </ng-template>
    </kz-accordion-item>

    <kz-accordion-item>
      <ng-template kzAccordionTitle >
        <h3 class="kz-accordion__title" #questions i18n="@@pro.listing.faq.item5.title">Can an interior designer save you money?</h3>
      </ng-template>
      <ng-template kzAccordionContent>
        <div  #responses class="kz-accordion__content-wrapper" id="itemA5">
          <div class="cols col-img-right">
            <app-picture-source
              imgSrc="/assets/images/annuaire/faq/04A.svg"
              width="204" height="132"
              [presets]="'w1000' | imgPreset"
              imgFitHeight="true"
              useWebp="false" useLazyLoad="true"
            ></app-picture-source>
            <div>
              <p i18n="@@pro.listing.faq.item5.bloc1.l1">Choosing your tiles, parquet, paintings or any other element of your furniture requires a certain financial involvement, where there would be no question of making a mistake.
                <strong>Avoid association errors, wrong dimensions and unnecessary purchases thanks to your
                  decorator.</strong></p>
              <br>
              <p i18n="@@pro.listing.faq.item5.bloc1.l2">On the lookout for new products and aware of the latest trends, the interior designer knows how to find you THE product that meets your needs and your budget. The decorator sometimes has
                <strong>prices negotiated with certain shops</strong> which he can pass on to you when purchasing.</p>
            </div>
          </div>
          <div class="cols col-img-left">
            <app-picture-source
              imgSrc="/assets/images/annuaire/faq/04B.svg"
              width="222" height="114"
              [presets]="'w1000' | imgPreset"
              imgFitHeight="true"
              useWebp="true" useLazyLoad="true"
            ></app-picture-source>
            <div>
              <p i18n="@@pro.listing.faq.item5.bloc2.l1">And for the tightest budgets, some interior decorators offer advice on layout, keeping your old furniture and giving it a makeover. This technique is called home staging! This is a common practice when you want to value a home during a sale or as part of a rental.</p>
              <br>
              <p><strong i18n="@@pro.listing.faq.item5.bloc2.l2">Save time, money and energy: your decorator takes care of everything!</strong></p>
            </div>
          </div>
          <a kzButton buttonStyle="flat" buttonTxtStyle="none" target="_blank" [href]="blogUrl + 'decoration-dinterieur/10-idees-deco-petits-budgets-pour-relooker-votre-interieur/#more-25477'"><span i18n="@@pro.listing.faq.item5.cta">10 special “low budget” ideas to decorate your interior</span></a>
        </div>
      </ng-template>
    </kz-accordion-item>

<!--    <kz-accordion-item>-->
<!--      <ng-template kzAccordionTitle >-->
<!--        <h3 class="kz-accordion__title" #questions i18n="@@pro.listing.faq.item6.title">What are the stages of a collaboration with an interior designer?</h3>-->
<!--      </ng-template>-->
<!--      <ng-template kzAccordionContent>-->
<!--        <div  #responses class="kz-accordion__content-wrapper" id="itemA6">-->
<!--          <ul class="kz-accordion__item-vlist">-->
<!--            <li>-->
<!--              <app-picture-source-->
<!--                imgSrc="/assets/images/annuaire/faq/05A.svg"-->
<!--                height="35" width="35"-->
<!--                [presets]="'w1000' | imgPreset"-->
<!--                imgFitHeight="true"-->
<!--                useWebp="false" useLazyLoad="true"-->
<!--              ></app-picture-source>-->
<!--              <p><ng-container i18n="@@pro.listing.faq.item6.bloc1">Define your project, your desires, your budget and your style.</ng-container></p>-->
<!--            </li>-->
<!--            <li>-->
<!--              <app-picture-source-->
<!--                imgSrc="/assets/images/annuaire/faq/05B.svg"-->
<!--                height="35" width="35"-->
<!--                [presets]="'w1000' | imgPreset"-->
<!--                imgFitHeight="true"-->
<!--                useWebp="false" useLazyLoad="true"-->
<!--              ></app-picture-source>-->
<!--              <p><ng-container i18n="@@pro.listing.faq.item6.bloc2">First proposals of the interior decorator with moodboard, 3D plan, plans, models, decoration ideas.</ng-container></p>-->
<!--            </li>-->
<!--            <li>-->
<!--              <app-picture-source-->
<!--                imgSrc="/assets/images/annuaire/faq/05C.svg"-->
<!--                height="35" width="35"-->
<!--                [presets]="'w1000' | imgPreset"-->
<!--                imgFitHeight="true"-->
<!--                useWebp="false" useLazyLoad="true"-->
<!--              ></app-picture-source>-->
<!--              <p><ng-container i18n="@@pro.listing.faq.item6.bloc3">You and the decorator then agree on the project and start the work.</ng-container></p>-->
<!--            </li>-->
<!--            <li>-->
<!--              <app-picture-source-->
<!--                imgSrc="/assets/images/annuaire/faq/05D.svg"-->
<!--                height="35" width="35"-->
<!--                [presets]="'w1000' | imgPreset"-->
<!--                imgFitHeight="true"-->
<!--                useWebp="false" useLazyLoad="true"-->
<!--              ></app-picture-source>-->
<!--              <p><ng-container i18n="@@pro.listing.faq.item6.bloc4">Launch of the project, coordinated by the interior designer on site or remotely.</ng-container></p>-->
<!--            </li>-->
<!--          </ul>-->
<!--          <a kzButton buttonStyle="flat" buttonTxtStyle="none" target="_blank" [routerLink]="['/pro', 'exchange-secure-payment'] | kzLocalize"><span i18n="@@pro.listing.faq.item6.cta">The stages of a collaboration with a decorator</span></a>-->
<!--        </div>-->
<!--      </ng-template>-->
<!--    </kz-accordion-item>-->

    <kz-accordion-item>
      <ng-template kzAccordionTitle >
        <h3 class="kz-accordion__title" #questions i18n="@@pro.listing.faq.item7.title">Decotherapy, why does an interior where we feel good help us feel better?</h3>
      </ng-template>
      <ng-template kzAccordionContent>
        <div  #responses class="kz-accordion__content-wrapper" id="itemAA7">
          <p><ng-container i18n="@@pro.listing.faq.item7.bloc1.l1"><strong>Arranging your living space in your image is a
            source of fulfillment</strong> for many households. Whether you are a fan of a refined decoration, a subdued atmosphere or addicted to green plants, having a decoration that suits you is the best way to feel at home.</ng-container></p>
          <p><ng-container i18n="@@pro.listing.faq.item7.bloc1.l2">Stimulate your brain every day with decoration, it's tempting, right? Your living space should be in your image and help you feel good, thanks to
            <strong>a decoration that pleases you and makes you happy</strong>. The decoration is good for morale, so why deprive yourself of it?</ng-container></p>


          <div class="cols col-img-left">
            <app-picture-source
              imgSrc="/assets/images/annuaire/faq/06A.png"
              width="300" height="240"
              [presets]="'w300' | imgPreset"
              imgFitHeight="true"
              useWebp="true" useLazyLoad="true"
            ></app-picture-source>
            <div>
              <p i18n="@@pro.listing.faq.item7.bloc2.l1">Do you want to get started in decotherapy?</p>
              <br>
              <ul class="classic-list">
                <li i18n="@@pro.listing.faq.item7.bloc2.list.item1">Choose objects that bring back fond memories or are visually attractive.</li>
                <li i18n="@@pro.listing.faq.item7.bloc2.list.item2">Ventilate your room and drive out all the negative energies that are there.</li>
                <li i18n="@@pro.listing.faq.item7.bloc2.list.item3">Light a candle and diffuse pleasant scents that stimulate or soothe you.</li>
                <li i18n="@@pro.listing.faq.item7.bloc2.list.item4">Declutter the space around you.</li>
              </ul>
              <a kzButton buttonStyle="flat" buttonTxtStyle="none" target="_blank" [href]="blogUrl + 'decoration-dinterieur/quel-est-le-prix-des-prestations-dun-decorateur-dinterieur/#more-25677'"><span i18n="@@pro.listing.faq.item7.cta">Decotherapy, decoration dedicated to well-being</span></a>
            </div>
          </div>
        </div>


      </ng-template>
    </kz-accordion-item>
  </ng-container>

  <ng-container *ngIf="jobType === 'architect'">

    <kz-accordion-item>
      <ng-template kzAccordionTitle >
        <h3 class="kz-accordion__title" #questions i18n="@@pro.listing.faq.archi.item1.title">How much does an interior designer cost / what is the price of an interior designer?</h3>
      </ng-template>
      <ng-template kzAccordionContent>
        <div  #responses class="kz-accordion__content-wrapper" id="itemB1">
          <p i18n="@@pro.listing.faq.archi.item1.bloc1.l1">Each interior designer will have his own price list depending on his reputation, his services and his geographical area. </p>
          <p i18n="@@pro.listing.faq.archi.item1.bloc1.l2">We can give you an indication of the average price of an interior designer, depending on the space to be redesigned. Please note that these prices are not binding, it will depend on the professional you choose.</p>

          <table>
            <tr>
              <th><ng-container i18n="@@pro.listing.faq.archi.item1.table.col1.title">Surface concerned </ng-container></th>
              <th><ng-container i18n="@@pro.listing.faq.archi.item1.table.col2.title">Average price / m²</ng-container></th>
            </tr>
            <tr>
              <td><ng-container i18n="@@pro.listing.faq.archi.item1.table.col1.l1">Less than 50m²</ng-container></td>
              <td><ng-container i18n="@@pro.listing.faq.archi.item1.table.col2.l1">Approximately 65€/m² excl. taxes</ng-container></td>
            </tr>
            <tr>
              <td><ng-container i18n="@@pro.listing.faq.archi.item1.table.col1.l2">Between 50 and 150 m²</ng-container></td>
              <td><ng-container i18n="@@pro.listing.faq.archi.item1.table.col2.l2">Approximately 55€/m² excl. taxes</ng-container></td>
            </tr>
            <tr>
              <td><ng-container i18n="@@pro.listing.faq.archi.item1.table.col1.l3">Between 150 and 250 m²</ng-container></td>
              <td><ng-container i18n="@@pro.listing.faq.archi.item1.table.col2.l3">Approximately 45€/m² excl. taxes</ng-container></td>
            </tr>
            <tr>
              <td><ng-container i18n="@@pro.listing.faq.archi.item1.table.col1.l4">More than 250 m²</ng-container></td>
              <td><ng-container i18n="@@pro.listing.faq.archi.item1.table.col2.l4">On request</ng-container></td>
            </tr>
          </table>
        </div>
      </ng-template>
    </kz-accordion-item>

    <kz-accordion-item>
      <ng-template kzAccordionTitle >
        <h3 class="kz-accordion__title" #questions i18n="@@pro.listing.faq.archi.item2.title">Interior designer or interior decorator ?</h3>
      </ng-template>
      <ng-template kzAccordionContent>
        <div  #responses class="kz-accordion__content-wrapper" id="itemB2">
          <p>
            <ng-container i18n="@@pro.listing.faq.archi.item2.bloc1.l1.a">Depending on your project, an architect and a <a [routerLink]="['/', 'pro', 'interior-decorator'] | kzLocalize">decorator</a> will not be of the same use.</ng-container>
            <ng-container i18n="@@pro.listing.faq.archi.item2.bloc1.l1.b">Unlike a decorator, an interior architect will be able to modify the structure of your home, by restructuring your space (dropping or creating partitions).</ng-container>
            <ng-container i18n="@@pro.listing.faq.archi.item2.bloc1.l1.c">He will also be able to design the plans for evacuation, electrical supply, heating and air conditioning.</ng-container>
            <ng-container i18n="@@pro.listing.faq.archi.item2.bloc1.l1.d">He will work on the staircases or improve the lighting and brightness of the space.</ng-container>
          </p>
          <p><ng-container i18n="@@pro.listing.faq.archi.item2.bloc1.l2">Finally, your interior designer can manage and direct the construction site.</ng-container></p>
        </div>
      </ng-template>
    </kz-accordion-item>

    <kz-accordion-item>
      <ng-template kzAccordionTitle >
        <h3 class="kz-accordion__title" #questions i18n="@@pro.listing.faq.archi.item3.title">How to find/choose an interior designer?</h3>
      </ng-template>
      <ng-template kzAccordionContent>
        <div  #responses class="kz-accordion__content-wrapper" id="itemB3">
          <p>
            <ng-container i18n="@@pro.listing.faq.archi.item3.bloc1.l1.a">With our folder of interior designers, you can easily find the right design professional for you. </ng-container>
            <ng-container i18n="@@pro.listing.faq.archi.item3.bloc1.l1.b">More than 49 verified <a [routerLink]="['/', 'pro', 'interior-architect'] | kzLocalize">interior designers</a> are proposed to you.</ng-container>
            <ng-container i18n="@@pro.listing.faq.archi.item3.bloc1.l1.c">Depending on your location, your style and your project, find the professional who looks like you and who will be able to best meet your expectations.</ng-container>
          </p>
          <p><ng-container i18n="@@pro.listing.faq.archi.item3.bloc1.l2">Consult our interior designers in <a [routerLink]="['/', 'pro', 'interior-architect', 'paris'] | kzLocalize">Paris</a>, <a [routerLink]="['/', 'pro', 'interior-architect', 'lille'] | kzLocalize">Lille</a> ...etc</ng-container></p>
        </div>
      </ng-template>
    </kz-accordion-item>

    <kz-accordion-item>
      <ng-template kzAccordionTitle >
        <h3 class="kz-accordion__title" #questions i18n="@@pro.listing.faq.archi.item4.title">Why use an interior designer?</h3>
      </ng-template>
      <ng-template kzAccordionContent>
        <div  #responses class="kz-accordion__content-wrapper" id="itemB4">
          <p><ng-container i18n="@@pro.listing.faq.archi.item4.bloc1.l1">Do you have ideas but need help to implement them, do you lack time to manage a project or do you wish to delegate certain tasks?</ng-container></p>
          <p><ng-container i18n="@@pro.listing.faq.archi.item4.bloc1.l2">An interior designer is the ideal person for your interior design project, working on the volumes of your space! He will be able to advise you on partitioning, creating new spaces, or coordinating materials and styles.</ng-container></p>
        </div>
      </ng-template>
    </kz-accordion-item>

    <kz-accordion-item>
      <ng-template kzAccordionTitle >
        <h3 class="kz-accordion__title" #questions i18n="@@pro.listing.faq.archi.item5.title">What is the role of an interior designer ?</h3>
      </ng-template>
      <ng-template kzAccordionContent>
        <div  #responses class="kz-accordion__content-wrapper" id="itemB5">
          <p>
            <ng-container i18n="@@pro.listing.faq.archi.item5.bloc1.l1.a">He designs and creates aesthetic, comfortable and functional interior spaces by playing with volumes, light, furniture, colors and materials.</ng-container>
            <ng-container i18n="@@pro.listing.faq.archi.item5.bloc1.l1.b">He must also take into account all the technical and budgetary constraints of his client.</ng-container>
          </p>
        </div>
      </ng-template>
    </kz-accordion-item>

    <kz-accordion-item>
      <ng-template kzAccordionTitle >
        <h3 class="kz-accordion__title" #questions i18n="@@pro.listing.faq.archi.item6.title">What is the minimum surface area for an interior designer?</h3>
      </ng-template>
      <ng-template kzAccordionContent>
        <div  #responses class="kz-accordion__content-wrapper" id="itemB6">
          <p>
            <ng-container i18n="@@pro.listing.faq.archi.item6.bloc1.l1.a">No matter what your surface area is, you may need to call on the services of an interior designer for 20m² or 150m²!</ng-container>
            <ng-container i18n="@@pro.listing.faq.archi.item6.bloc1.l1.b">Indeed, from the moment you wish to touch the volumes of your house, flat or other, it is the interior designer who will be able to take care of it, by also proposing you decorative arrangements and furnishings according to your style and your desires.</ng-container>
          </p>
        </div>
      </ng-template>
    </kz-accordion-item>

    <kz-accordion-item>
      <ng-template kzAccordionTitle >
        <h3 class="kz-accordion__title" #questions i18n="@@pro.listing.faq.archi.item7.title">How do I find an interior designer in a city, such as Paris?</h3>
      </ng-template>
      <ng-template kzAccordionContent>
        <div  #responses class="kz-accordion__content-wrapper" id="itemB7">
          <p>
            <ng-container i18n="@@pro.listing.faq.archi.item7.bloc1.l1.a">Our directory of professionals is evolving! Indeed, you can now search for your decoration professional by location.</ng-container>
            <ng-container i18n="@@pro.listing.faq.archi.item7.bloc1.l1.b">If you are in Paris, you just have to select the city to have an overview of the interior designers present in the region, or who can carry out your project remotely.</ng-container>
          </p>
        </div>
      </ng-template>
    </kz-accordion-item>

  </ng-container>

</kz-accordion>
